// eslint-disable-next-line import/no-cycle
import {
  GET_PROFILE,
  PROFILE,
  PROFILE_ERROR,
  PROFILE_SUCCESS,
  SEND_OTP_PROFILE_EMAIL,
  SEND_OTP_PROFILE_MOBILE,
  UPDATE_PROFILE,
  UPDATE_PROFILE_EMAIL_MOBILE,
  UPDATE_PROFILE_SECONDS,
} from 'redux/actions';

export const getProfile = (id) => ({
  type: GET_PROFILE,
  payload: { id },
});

export const profile = (info) => ({
  type: PROFILE,
  payload: info,
});



export const profileUpdate = (
  id,
  name,
  nationcode,
  // sheba
) => {
  return {
    type: UPDATE_PROFILE,
    payload: {
      id,
      name,
      nationcode,
      //sheba 
    },
  };
};

export const profileSecondsUpdate = (seconds) => {
  return {
    type: UPDATE_PROFILE_SECONDS,
    payload: seconds,
  };
};

export const profileUpdateMobileEmail = (id, input, code) => {
  return {
    type: UPDATE_PROFILE_EMAIL_MOBILE,
    payload: { id, input, code },
  };
};

export const sendOtpProfileUpdateMobile = (id, mobile) => {
  return {
    type: SEND_OTP_PROFILE_MOBILE,
    payload: { id, mobile },
  };
};

export const sendOtpProfileUpdateEmail = (id, email) => {
  return {
    type: SEND_OTP_PROFILE_EMAIL,
    payload: { id, email },
  };
};

export const profileSuccess = (message) => ({
  type: PROFILE_SUCCESS,
  payload: { message },
});
export const profileError = (message) => ({
  type: PROFILE_ERROR,
  payload: { message },
});
